import React            from 'react';
import Form             from './Form';
import { words }        from '../../utils/dictionary';
import colors           from '../../utils/colors';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { makeStyles }   from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        position:        'fixed',
        top:             100,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        transition:      'all 0.6s',
        overflow:        'hidden',
        backgroundColor: colors.dark
    },
    icon_container: {
       position:        'absolute',
       top:             30,
       height:          30,
       width:           30,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       backgroundColor:  colors.dark,
       border:          '1px solid #FFF',
       borderRadius:    '50%',
       cursor:          'pointer',
       transition:      'all 0.7s'
    },
    icon: {
        color: '#FFF'
    },
    textContainer: {
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       flexFlow:        'column'
    },
    text: {
      fontSize:   22,
      lineHeight: 1.9,
      color:      '#FFF'
    },
    button: {
        height:          40,
        marginTop:       15,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        backgroundColor: '#FFF',
        border:          '1px solid #FFF',
        borderRadius:    '0.5em',
        fontSize:        20,
        transition:      'width 1.3s',
        color:           colors.dark,
        cursor:          'pointer',
        '&:hover': {
            border:         `1px solid #FFF`,
            color:          `#FFF`,
            backgroundColor: colors.dark,
        }
      }
}))

type InputProps = {
  size:                number[];
  navbarSize:          number;
  teacherId:           number;
  lang:                string;
  code:                string;
  userRole:            string;
  wideScreen:          boolean;
  showCodeInput:       boolean;
  showSmallNavBar:     boolean;
  setShowSmallNavBar:  (val: boolean) => void;
  setShowCodeInput:    (val: boolean) => void;
  setCode:             (val: string) => void;
  handleSubmitCode:    () => void;
}

const Input: React.FC<InputProps> = ({ 
  size,
  navbarSize,
  teacherId,
  lang,
  showCodeInput,
  showSmallNavBar,
  code,
  userRole,
  wideScreen,
  setShowSmallNavBar,
  setShowCodeInput,
  setCode,
  handleSubmitCode
}) => {

  const classes = useStyles();

  const [codeErr, setCodeErr]   = React.useState('')
  const [showForm, setShowForm] = React.useState(userRole !== 'teacher')


  React.useEffect(() => {
     if (teacherId <= 0) {
      setShowForm(false)
     }
  },[teacherId])


  React.useEffect(() => {
    if (!showCodeInput) {
        setCodeErr('')
        setShowForm(userRole !== 'teacher' && teacherId <= 0)
    }
  },[showCodeInput, userRole, teacherId])


  React.useEffect(() => {
    if (showSmallNavBar) {
        setShowCodeInput(false)
    }
  },[showSmallNavBar, setShowCodeInput])

  
  const handleClose = () => {
    setCode('')
    setCodeErr('')
    setShowCodeInput(false)
    setShowForm(userRole !== 'teacher' && teacherId <= 0)
    if (showSmallNavBar) {
        setShowSmallNavBar(false)
    }
  }

  const handleSubmit = () => {
      if (!code.length) {
          setCodeErr(`${ words['emptyCode'][lang] }`)
      }
      else if (isNaN(+code)) {
        setCodeErr(`${ words['inputIsNaN'][lang] }`)
      }
      else {
        handleSubmitCode()
        handleClose()
      }
  }

  const handleShowForm = () => {
    setShowForm(true)
  }


  const [rootStyle, buttonStyle, iconContainerStyle] = React.useMemo(() => {
    return [
        {
          width:        showCodeInput ? (wideScreen ? 400 : '100vw') : 0,
          opacity:      showCodeInput ? 1 : 0,
          height:       wideScreen ? 250 : size[1] - 100,
          right:        wideScreen ? navbarSize + 5 : 0,
          borderRadius: wideScreen ? '1em' : 0,
        },
        {
          width: showCodeInput ? 170 : 0,
        },
        {
          right: showCodeInput ? (wideScreen ? 30 : 40) : -700,
        }
     ]
  },[size, navbarSize, showCodeInput, wideScreen])


  return (
    <div 
       className = { classes.root }
       style     = { rootStyle }
    >
        <div 
          className = { classes.icon_container }
          style     = { iconContainerStyle }
        >
          <CloseRoundedIcon 
             className = { classes.icon }
             onClick   = { handleClose }
          />
        </div>
        {
          showForm
          &&
          <Form
           lang          = { lang }
           showCodeInput = { showCodeInput }
           code          = { code }
           codeErr       = { codeErr }
           setCode       = { setCode }
           />
        }
        {
          !showForm
          &&
          <div className = { classes.textContainer }>
             <div 
                dir       = 'rtl'
                className = { classes.text }
             >
               { `${ words['myTeacherCode'][lang] }` }
             </div>
             <div className = { classes.text }>
               { teacherId }
             </div>
          </div>
        }
        {
          userRole !== 'teacher'
          &&
          <div 
            className = { classes.button }
            style     = { buttonStyle }
            onClick   = { showForm ? handleSubmit : handleShowForm }
         >
             { `${ showForm ? words['ok'][lang] : words['changeTeacherCode'][lang] }` }
         </div>
        }
    </div>
  );
}




export default Input;

